<template>
  <div class="py-2 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">Empresas</h5>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto">
                  <router-link :to="{ name: 'Empresa', params: { id: 'new' } }">
                    <button class="mt-1 mb-0 btn btn-outline-success btn-sm mt-sm-0" type="button" name="button">
                      +&nbsp; Nova Empresa
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="mt-3">
              <input v-model="search" type="text" class="form-control" placeholder="Pesquisar empresa...">
            </div>
          </div>
          <div class="p-4">
            <div v-if="empresasFiltered.length > 0" class="row">
              <div class="col-lg-3 col-md-4 col-sm-6" v-for="empresa in empresasFiltered" :key="empresa.id">
                <empresa-card :empresa="empresa" />
              </div>
            </div>
            <div v-else class="text-center py-5">
              <i class="fas fa-search mb-3" style="font-size: 2rem; color: #6c757d;"></i>
              <h5 class="text-muted">Nenhuma empresa encontrada</h5>
              <p class="text-muted mb-0" v-if="search">
                Tente ajustar os filtros de busca
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import { errorToast } from '@/utils/alerts';
import EmpresaCard from './components/EmpresaCard.vue';

export default {
  name: "Empresas",
  components: {
    EmpresaCard
  },
  data() {
    return {
      empresas: [],
      search: '',
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const response = await api.get('/empresa');
        this.empresas = response.data;
      } catch (error) {
        errorToast('Erro ao carregar empresas');
        console.error(error);
      }
    }
  },
  computed: {
    unidades() {
      return {
        3: 'BITZ',
        4: 'BS'
      };
    },
    empresasFiltered() {
      if (!this.search) {
        return this.empresas;
      }

      const searchLower = this.search.toLowerCase();
      return this.empresas.filter(empresa => 
        empresa.razaoSocial.toLowerCase().includes(searchLower) ||
        (empresa.nomeFantasia && empresa.nomeFantasia.toLowerCase().includes(searchLower)) ||
        empresa.documento.toLowerCase().includes(searchLower) ||
        this.unidades[empresa.conexaUnidadeId]?.toLowerCase().includes(searchLower)
      );
    }
  }
};
</script>
